<mat-form-field style="width: 100%;" *ngIf="selectedItem">
  <mat-select multiple [compareWith]="compareFn" [formControl]="itemControl" [(ngModel)]="selectedItem"
    (selectionChange)="onChange()">
    <mat-select-trigger>
      <mat-chip-list>
        <mat-chip *ngFor="let item of selectedItem" #el>
          {{ item[field]}}
        </mat-chip>
      </mat-chip-list>
    </mat-select-trigger>
    <mat-option *ngFor="let item of allItem" [value]="item">{{ item[field] }} </mat-option>
  </mat-select>
</mat-form-field>
<!-- {{selectedItem|json}} -->


<mat-form-field style="width: 100%;" *ngIf="!selectedItem">
  <mat-select multiple [compareWith]="compareFn" [(ngModel)]="selectedItem" (selectionChange)="onChange()">
    <mat-select-trigger>
      <mat-chip-list>
        <mat-chip *ngFor="let item of selectedItem" #el>
          {{ item[field] }}
        </mat-chip>
      </mat-chip-list>
    </mat-select-trigger>
    <mat-option *ngFor="let item of allItem" [value]="item">{{ item[field] }} </mat-option>
  </mat-select>
</mat-form-field>
